export * from "-!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--8-2!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/sass-loader/dist/cjs.js??ref--8-3!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=0&lang=scss&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=style&index=0&lang=scss&
// module id = 132
// module chunks = 1